import React from 'react';
import { WhatsAppOutlined } from '@ant-design/icons';

const WhatsAppFloat = () => {
  const phoneNumber = '919301021020'; // Format: country code + number (no + or spaces)
  const message = 'Hi! I am interested in Wellness management platform.'; // Default message
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <>
      <style>{`
        .whatsapp-float {
          position: fixed;
          bottom: 30px;
          right: 30px;
          z-index: 1000;
          transition: all 0.3s ease;
        }
        
        .whatsapp-float-btn {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: #25D366;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 16px rgba(37, 211, 102, 0.4);
          cursor: pointer;
          transition: all 0.3s ease;
          border: none;
          text-decoration: none;
        }
        
        .whatsapp-float-btn:hover {
          background: #20BA5A;
          transform: scale(1.1);
          box-shadow: 0 6px 24px rgba(37, 211, 102, 0.6);
        }
        
        .whatsapp-float-btn:active {
          transform: scale(0.95);
        }
        
        .whatsapp-icon {
          color: #fff;
          font-size: 32px;
          animation: pulse 2s infinite;
        }
        
        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
          100% {
            transform: scale(1);
          }
        }
        
        /* Ripple effect */
        .whatsapp-float-btn::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: #25D366;
          opacity: 0.6;
          animation: ripple 2s infinite;
        }
        
        @keyframes ripple {
          0% {
            transform: scale(1);
            opacity: 0.6;
          }
          100% {
            transform: scale(1.5);
            opacity: 0;
          }
        }
        
        /* Tooltip */
        .whatsapp-tooltip {
          position: absolute;
          right: 75px;
          top: 50%;
          transform: translateY(-50%);
          background: #fff;
          color: #333;
          padding: 10px 16px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          white-space: nowrap;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.3s ease;
        }
        
        .whatsapp-tooltip::after {
          content: '';
          position: absolute;
          right: -6px;
          top: 50%;
          transform: translateY(-50%);
          width: 0;
          height: 0;
          border-left: 6px solid #fff;
          border-top: 6px solid transparent;
          border-bottom: 6px solid transparent;
        }
        
        .whatsapp-float:hover .whatsapp-tooltip {
          opacity: 1;
        }
        
        /* Mobile responsive */
        @media (max-width: 768px) {
          .whatsapp-float {
            bottom: 20px;
            right: 20px;
          }
          
          .whatsapp-float-btn {
            width: 56px;
            height: 56px;
          }
          
          .whatsapp-icon {
            font-size: 28px;
          }
          
          .whatsapp-tooltip {
            display: none; /* Hide tooltip on mobile */
          }
        }
      `}</style>

      <div className="whatsapp-float">
        <div className="whatsapp-tooltip">
          Chat with us on WhatsApp!
        </div>
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-float-btn"
          aria-label="Chat on WhatsApp"
        >
          <WhatsAppOutlined className="whatsapp-icon" />
        </a>
      </div>
    </>
  );
};

export default WhatsAppFloat;
